import { useEffect, useRef } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
export default function ComoFunciona() {
  const sectionRef = useRef<HTMLElement>(null);
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("opacity-100", "translate-y-0");
          entry.target.classList.remove("opacity-0", "translate-y-8");
        }
      });
    }, {
      threshold: 0.15
    });
    itemRefs.current.forEach(el => {
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);
  const articles = [{
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685383/img/quien-puede-usar-ortodoncia-invisible-featured.webp",
    alt: "Quién puede usar ortodoncia invisible",
    date: "22/05/2026",
    comments: "No hay comentarios",
    title: "Quién puede usar ortodoncia invisible",
    excerpt: "Descubre quién puede usar ortodoncia invisible, en qué casos funciona mejor y cuándo un ortodoncista debe valorar otras opciones de tratamiento.",
    featured: true
  }, {
    image: null,
    alt: null,
    date: "21/05/2026",
    comments: "No hay comentarios",
    title: "Cómo limpiar alineadores transparentes bien",
    excerpt: "Aprende cómo limpiar alineadores transparentes sin dañarlos, evitar mal olor, manchas y bacterias, y mantener tu tratamiento más higiénico.",
    featured: false
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685383/img/se-pueden-quitar-los-alineadores-para-comer-featured.webp",
    alt: "¿Se pueden quitar los alineadores para comer?",
    date: "20/05/2026",
    comments: "No hay comentarios",
    title: "¿Se pueden quitar los alineadores para comer?",
    excerpt: "Sí, se pueden quitar los alineadores para comer. Te explicamos cuándo hacerlo, qué evitar y cómo cuidarlos sin afectar el tratamiento.",
    featured: true
  }];
  return <section ref={sectionRef} className="bg-background text-foreground overflow-hidden">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,900;1,700&family=DM+Sans:wght@300;400;500&display=swap');`}</style>

      <div className="relative bg-foreground text-background px-6 py-20 md:px-16 lg:px-24">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-end">
          <div ref={el => {
          itemRefs.current[0] = el;
        }} className="opacity-0 translate-y-8 transition-all duration-700 delay-100">
            <span className="block text-xs font-medium uppercase tracking-[0.35em] mb-6 opacity-50" style={{
            fontFamily: "'DM Sans', sans-serif"
          }}>
              Sistema Rio3D
            </span>
            <h2 className="text-6xl md:text-7xl lg:text-8xl font-black leading-none mb-0" style={{
            fontFamily: "'Playfair Display', serif"
          }}>
              Cómo
              <br />
              <em className="italic">Funciona</em>
            </h2>
          </div>

          <div ref={el => {
          itemRefs.current[1] = el;
        }} className="opacity-0 translate-y-8 transition-all duration-700 delay-300">
            <div className="w-12 h-px bg-background opacity-30 mb-6" />
            <p className="text-base leading-relaxed opacity-70" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 300
          }}>
              El sistema Rio3D se compone de una serie de Alineadores
              Transparentes que se colocan secuencialmente, cada alineador lleva
              implícito un movimiento controlado que finalmente se transmite a
              los dientes para enderezarlos en un tiempo perfectamente definido,
              dando como resultado un sistema ortodóntico completamente efectivo
              y eficiente.
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 md:px-16 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          <div ref={el => {
          itemRefs.current[2] = el;
        }} className="md:col-span-5 opacity-0 translate-y-8 transition-all duration-700 delay-150">
            <article className="group h-full flex flex-col border border-border rounded-none overflow-hidden hover:shadow-2xl transition-shadow duration-500">
              <div className="relative overflow-hidden">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685383/img/quien-puede-usar-ortodoncia-invisible-featured.webp" alt="Quién puede usar ortodoncia invisible" className="w-full h-auto group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-foreground/10 group-hover:bg-foreground/0 transition-colors duration-500" />
              </div>
              <div className="flex flex-col flex-1 p-7 bg-card">
                <div className="flex items-center gap-3 mb-4" style={{
                fontFamily: "'DM Sans', sans-serif"
              }}>
                  <Badge variant="outline" className="rounded-none text-xs font-normal border-foreground/20 text-muted-foreground px-2 py-0.5">
                    22/05/2026
                  </Badge>
                  <span className="text-xs text-muted-foreground">
                    No hay comentarios
                  </span>
                </div>
                <h3 className="text-xl font-bold leading-tight mb-3 text-foreground" style={{
                fontFamily: "'Playfair Display', serif"
              }}>
                  Quién puede usar ortodoncia invisible
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed flex-1 mb-6" style={{
                fontFamily: "'DM Sans', sans-serif",
                fontWeight: 300
              }}>
                  Descubre quién puede usar ortodoncia invisible, en qué casos
                  funciona mejor y cuándo un ortodoncista debe valorar otras
                  opciones de tratamiento.
                </p>
                <Button variant="default" className="self-start rounded-none px-6 py-2 text-xs tracking-widest uppercase font-medium" style={{
                fontFamily: "'DM Sans', sans-serif"
              }}>
                  Leer más
                </Button>
              </div>
            </article>
          </div>

          <div className="md:col-span-7 flex flex-col gap-6">
            <div ref={el => {
            itemRefs.current[3] = el;
          }} className="opacity-0 translate-y-8 transition-all duration-700 delay-300 flex-1">
              <article className="group h-full border border-border rounded-none overflow-hidden hover:shadow-2xl transition-shadow duration-500 bg-card">
                <div className="p-8 flex flex-col h-full">
                  <div className="flex items-center gap-3 mb-5" style={{
                  fontFamily: "'DM Sans', sans-serif"
                }}>
                    <Badge variant="outline" className="rounded-none text-xs font-normal border-foreground/20 text-muted-foreground px-2 py-0.5">
                      21/05/2026
                    </Badge>
                    <span className="text-xs text-muted-foreground">
                      No hay comentarios
                    </span>
                  </div>

                  <div className="flex-1 flex flex-col md:flex-row gap-8 items-start">
                    <div className="flex-1">
                      <h3 className="text-2xl md:text-3xl font-bold leading-tight mb-4 text-foreground" style={{
                      fontFamily: "'Playfair Display', serif"
                    }}>
                        Cómo limpiar alineadores transparentes bien
                      </h3>
                      <p className="text-sm text-muted-foreground leading-relaxed mb-6" style={{
                      fontFamily: "'DM Sans', sans-serif",
                      fontWeight: 300
                    }}>
                        Aprende cómo limpiar alineadores transparentes sin
                        dañarlos, evitar mal olor, manchas y bacterias, y
                        mantener tu tratamiento más higiénico.
                      </p>
                      <Button variant="outline" className="rounded-none px-6 py-2 text-xs tracking-widest uppercase font-medium border-foreground text-foreground hover:bg-foreground hover:text-background transition-colors duration-300" style={{
                      fontFamily: "'DM Sans', sans-serif"
                    }}>
                        Leer más
                      </Button>
                    </div>
                    <div className="hidden md:block w-24 flex-shrink-0 self-center opacity-10">
                      <div className="text-8xl font-black text-foreground leading-none" style={{
                      fontFamily: "'Playfair Display', serif"
                    }}>
                        02
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </div>

            <div ref={el => {
            itemRefs.current[4] = el;
          }} className="opacity-0 translate-y-8 transition-all duration-700 delay-450 flex-1">
              <article className="group h-full border border-border rounded-none overflow-hidden hover:shadow-2xl transition-shadow duration-500 bg-card">
                <div className="flex flex-col sm:flex-row h-full">
                  <div className="sm:w-2/5 overflow-hidden flex-shrink-0">
                    <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685383/img/se-pueden-quitar-los-alineadores-para-comer-featured.webp" alt="¿Se pueden quitar los alineadores para comer?" className="w-full h-auto sm:h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  </div>
                  <div className="flex-1 p-7 flex flex-col justify-between">
                    <div>
                      <div className="flex items-center gap-3 mb-4" style={{
                      fontFamily: "'DM Sans', sans-serif"
                    }}>
                        <Badge variant="outline" className="rounded-none text-xs font-normal border-foreground/20 text-muted-foreground px-2 py-0.5">
                          20/05/2026
                        </Badge>
                        <span className="text-xs text-muted-foreground">
                          No hay comentarios
                        </span>
                      </div>
                      <h3 className="text-lg font-bold leading-tight mb-3 text-foreground" style={{
                      fontFamily: "'Playfair Display', serif"
                    }}>
                        ¿Se pueden quitar los alineadores para comer?
                      </h3>
                      <p className="text-sm text-muted-foreground leading-relaxed mb-5" style={{
                      fontFamily: "'DM Sans', sans-serif",
                      fontWeight: 300
                    }}>
                        Sí, se pueden quitar los alineadores para comer. Te
                        explicamos cuándo hacerlo, qué evitar y cómo cuidarlos
                        sin afectar el tratamiento.
                      </p>
                    </div>
                    <Button variant="default" className="self-start rounded-none px-6 py-2 text-xs tracking-widest uppercase font-medium" style={{
                    fontFamily: "'DM Sans', sans-serif"
                  }}>
                      Leer más
                    </Button>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </section>;
}